<template>
  <div class="shophome">
    <header class="header">
      <div class="local">东营<i class="iconfont">&#xe769;</i></div>
      <a href="#" class="search">
        <i class="iconfont">&#xe8b9;</i>
        <span>搜索</span></a
      >
      <a href="/shop/cart?channel=shop" class="cart">
        <i class="iconfont icon">&#xe70b;</i>
        <div class="nn">{{ this.$store.getters.mycart.length }}</div>
      </a>
    </header>
    <div class="search1">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item><img src="../../assets/home1.jpg"/></van-swipe-item>
        <van-swipe-item><img src="../../assets/home2.jpg"/></van-swipe-item>
        <van-swipe-item><img src="../../assets/home3.jpg"/></van-swipe-item>
      </van-swipe>
    </div>

    <nav class="menu">
      <a href="/shop/list" class="list">
        <i class="iconfont">&#xe61b;</i>
        <span>全部</span></a
      >
      <a href="/shop/list?category=flower" class="list">
        <i class="iconfont" style="font-size:2.8rem;">&#xfd68;</i>
        <span>鲜花装饰</span></a
      ><a href="/shop/list?category=sacrifice" class="list">
        <i class="iconfont" style="font-size:2.8rem;">&#xe76e;</i>
        <span>祭祀随葬品</span></a
      ><a href="/shop/list?category=other" class="list">
        <i class="iconfont">&#xe60b;</i>
        <span>其他</span></a
      >
    </nav>
    <div class="contentdiv content">
      <div class="classification">
        <div class="title">
          <h3 class="txt">今日精选内容</h3>
          <h3 class="classmore" style="display: none;">更多&gt;</h3>
        </div>
        <ul class="prolist">
          <template v-for="(item, index) in list">
            <li class="item" :key="index">
              <a href="javascript:void(0)" @click="goDetail(item.id)" style="color:#323232;">
                <dl>
                  <dt>
                    <img :src="item.firstPhoto" />
                  </dt>
                  <dd>
                    <p>{{ item.proName }}</p>
                    <p class="price">
                      ¥{{ item.price }}
                      <i
                        v-if="$store.getters.mycollect.indexOf(item.id) > -1"
                        class="iconfont"
                        style="color:#dea767;padding:0.3rem;display:block;"
                        @click.stop="cancelCollect(item.id)"
                        >&#xe627;</i
                      >
                      <i
                        v-else
                        class="iconfont"
                        style="padding:0.3rem;display:block;"
                        @click.stop="addCollect(item.id)"
                        >&#xe627;</i
                      >
                    </p>
                  </dd>
                </dl>
              </a>
            </li>
          </template>
        </ul>
      </div>
      <div class="clear-both"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shopHome',
  data() {
    return {
      list: [],
      total: 0,
      page: 1,
    }
  },
  created() {
    this.queryGoodsPage(this.page)
  },
  methods: {
    addCollect(id) {
      var that = this
      this.$submit(
        '/api/mycollect/addCollect',
        {
          myId: this.$store.getters.userId,
          goodsId: id,
        },
        function(res) {
          if (res['code'] === 1) {
            //that.$store.dispatch('mystatus', 0)
            // alert('OK')
            if (that.$store.getters.mycollect.indexOf(id) < 0) {
              that.$store.getters.mycollect.push(id)
            }
          }
        }
      )
    },
    cancelCollect(id) {
      var that = this
      this.$submit(
        '/api/mycollect/removeCollect',
        {
          myId: this.$store.getters.userId,
          goodsId: id,
        },
        function(res) {
          if (res['code'] === 1) {
            //that.$store.dispatch('mystatus', 0)
            // alert('OK')
            if (that.$store.getters.mycollect.indexOf(id) > -1) {
              let _index = that.$store.getters.mycollect.indexOf(id)
              that.$store.getters.mycollect.splice(_index, 1)
            }
          }
        }
      )
    },
    goDetail(id) {
      this.$router.push({ path: '/shop/detail/' + id, query: {} })
    },
    getCartCount() {
      return this.$store.getters.mycart.length
    },
    queryGoodsPage(page) {
      var that = this
      this.$queryPage(
        'ProGoods',
        { channel: 'shop', page: page },
        [
          'id',
          'firstPhoto',
          'proName',
          'specification',
          'gallery',
          'price',
          'proDetail',
          'proNotice',
          'proFeature',
        ],
        function(res) {
          that.$fill(that.list, res['data'])
          that.total = res['total']
        }
      )
    },
  },
}
</script>

<style>
.shophome .header {
  background-color: #fff;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 4.6rem;
  line-height: 4.6rem;
  display: flex;
  justify-content: space-between;
  font-size: 1.3rem;
}
.shophome .header .local {
  color: #323232;
  padding-left: 1.3rem;
}
.shophome .header .local:after {
  content: '';
  display: inline-block;
  width: 0.8rem;
  height: 0.48rem;
  margin-left: 0.04rem;

  background-size: contain;
}
.shophome .header .search {
  width: 25rem;
  height: 2.8rem;
  line-height: 2.8rem;
  color: #999;
  background: #eaeaea;
  display: flex;
  justify-content: center;
  margin: 0.9rem 0;
  border-radius: 0.4rem;
}
.shophome .header .search i {
  margin-right: 0.2rem;
}
.shophome .header .cart {
  width: 2.9rem;
  margin-right: 1rem;
  margin-top: 0.5rem;
  position: relative;
  line-height: 3.5rem;
}
.shophome .header .cart .icon {
  font-size: 2rem;
  color: #555;
}
.shophome .header .cart .nn {
  font-size: 1rem;
  color: #555;
  background: #dea767;
  position: absolute;
  top: 0;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50rem;
  line-height: 1.5rem;
  text-align: center;
  color: #fff;
}
.shophome .menu {
  background-color: #fff;
  width: 100%;
  height: 8rem;
  display: flex;
  box-shadow: 0 -0.027rem 0.05333rem rgb(0 0 0 / 10%);
}
.shophome .menu i {
  font-size: 2.8rem;
  color: #555;
}
.shophome .menu .list {
  flex: 1;
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  margin-top: 1.6rem;
  width: 5.6rem;
  height: 5.6rem;
}
.shophome .menu .list span {
  font-size: 1.4rem;
  color: #323232;
  margin-top: 1rem;
}
.shophome .menu .list .icon_style {
  width: 2.5rem;
  height: 2.5rem;
  fill: #ccc;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
}
.shophome .search1 {
  margin-top: 4.6rem;
  width: 100%;
  height: 17rem;
}
.shophome .search1 img {
  width: 100%;
}
.shophome .content {
  padding: 0 1.2rem;
}
.shophome .contentdiv {
  /* padding: 0 1.2rem; */
  background-color: #f3f3f3;
}
.shophome .contentdiv .classification {
  overflow: hidden;
}
.shophome .contentdiv .classification .title {
  height: 4rem;
  padding-top: 1rem;
}
.shophome .contentdiv .classification .title .txt {
  float: left;
  font-size: 1.4rem;
  color: #323232;
}
.shophome .contentdiv .classification .title .classmore {
  float: right;
}
.shophome .contentdiv .prolist .item:nth-of-type(odd) {
  margin-right: 1rem;
}
.shophome .contentdiv .prolist .item {
  float: left;
  width: calc(50% - 0.6rem);
  margin-bottom: 1rem;
  box-sizing: border-box;
  background-color: #fff;
}
.shophome .contentdiv .prolist .item dl {
  width: 100%;
}
.shophome .contentdiv .prolist .item dl dt img {
  width: 100%;
  max-height: 11.3rem;
  display: block;
}
.shophome .contentdiv .prolist .item dl dd {
  padding: 0.6em 1.4rem;
  font-size: 1.4rem;
  line-height: 2rem;
}
.shophome .contentdiv .prolist .item dl dd .price {
  padding-top: 0.3rem;
  color: #15a892;
}
.shophome .contentdiv .prolist .item dl dd .price i {
  float: right;
  position: relative;
  top: -0.5rem;
  display: block;
  color: #777;
}
.shophome .clear-both {
  clear: both;
  height: 5rem;
}
</style>
